import React, { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { Link, useNavigate } from 'react-router-dom'
import { styled } from 'styled-components'
import { useMyContext } from '../../components/provider/MyProvider'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'
import { formatNumberWithTruncation, onErrorImg, plusComma } from '../../js/script'
import LikeBtn from '../btn/LikeBtn'
import ProductCenterModal from '../product/ProductCenterModal'
import ProductModal from '../product/ProductModal'
import { useAppContext } from '../provider/AppProvider'
import { useCommonContext } from '../provider/CommonProvider'
import { IconStarOn } from '../svg/IconSvg'
import {
  BtnCart,
  DiscountedPrice,
  ProductBrandTitile,
  ProductImageArea,
  ProductItemWrap,
  ProductSalePrice,
  ProductTitle,
} from './ProductItem'

const imgURL = '/images'

export default function ShoppingProductListItem({
  item,
  setSubmitWish,
  items,
}: {
  item: any
  setSubmitWish: React.Dispatch<React.SetStateAction<boolean>>
  items: any
}) {
  const { isAppView } = useAppContext()
  const { hasAccessToken } = useCommonContext()
  const navigate = useNavigate()

  const [wish, setWish] = useState<boolean>(false)
  const [disCountAcc, setDisCountAcc] = useState<number>(0)
  const [wonShop, setWonShop] = useState<boolean>(false)
  const [isModals, setIsModals] = useState<boolean>(false)

  useEffect(() => {
    if (item) {
      const count = formatNumberWithTruncation((item?.salePrice - item?.immediateDiscountAmt) * 0.1)
      setDisCountAcc(Number(count.replaceAll(',', '')))
    }
  }, [item])

  useEffect(() => {
    if (item) {
      if (item.displayCategoryNos === '787334') {
        setWonShop(true)
      }
    }
  }, [item])

  useEffect(() => {
    setWish(item.liked)
  }, [item])

  return (
    // 상품내역 wrap

    <div className='product_item_wrap'>
      {/* 상품이미지 영역 */}
      <div className='product_image_area'>
        <div
          onClick={(event) => {
            event.preventDefault()
            if (isAppView) {
              RNPostMessage(AFWebLinkType.moveToLink, {
                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${item.productNo}`,
              })
            } else {
              navigate(`/product/${item.productNo}`)
            }
          }}
        >
          <div className='dim'></div>
          <img src={item.listImageUrls[0]} alt='' onError={onErrorImg} />
        </div>
      </div>

      <div className='list_content_wrap'>
        <div
          className='product_item'
          onClick={(event) => {
            event.preventDefault()
            if (isAppView) {
              RNPostMessage(AFWebLinkType.moveToLink, {
                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${item.productNo}`,
              })
            } else {
              navigate(`/product/${item.productNo}`)
            }
          }}
        >
          {/* 브랜드명 */}
          {item.brandName ? <div className='product_brand_title'>{item.brandName}</div> : null}

          {/* 상품명 */}
          <div className='product_title'>{item.productName}</div>

          {Math.floor((item.immediateDiscountAmt / item.salePrice) * 100) === 0 ? (
            <>
              <div className='discounted_price'>
                {/* 상품 할인 적용가 */}
                <p>{item.salePrice ? plusComma(item.salePrice - item.immediateDiscountAmt) : 0}원</p>
              </div>
            </>
          ) : (
            <>
              {/* 원 상품가 */}
              <div className='product_sale_price'>{plusComma(item.salePrice)}원</div>

              <div className='discounted_price'>
                <p className='percent'>{Math.floor((item.immediateDiscountAmt / item.salePrice) * 100)}%</p>

                {/* 상품 할인 적용가 */}
                <p>{item.salePrice ? plusComma(item.salePrice - item.immediateDiscountAmt) : 0}원</p>
              </div>
            </>
          )}

          {/* 최대혜택가 */}

          {!item?.accumulationUseInfo?.usable && !item.enableCoupons ? null : item?.salePrice -
              item?.immediateDiscountAmt -
              item?.couponDiscountAmt -
              (item?.accumulationAmtWhenBuyConfirm !== 0 ? item?.accumulationAmtWhenBuyConfirm : 0) -
              (item?.accumulationUseInfo?.usable ? Number(disCountAcc) : 0) ===
            Number(item?.salePrice - item?.immediateDiscountAmt) ? null : (
            <div className='max_benefit'>
              <p className='badge'>회원혜택가</p>

              <>
                <p>
                  {plusComma(
                    item?.salePrice -
                      item?.immediateDiscountAmt -
                      item?.couponDiscountAmt -
                      (item?.accumulationAmtWhenBuyConfirm !== 0 ? item?.accumulationAmtWhenBuyConfirm : 0) -
                      (item?.accumulationUseInfo?.usable ? Number(disCountAcc) : 0) <
                      0
                      ? 0
                      : item?.salePrice -
                          item?.immediateDiscountAmt -
                          item?.couponDiscountAmt -
                          (item?.accumulationAmtWhenBuyConfirm !== 0 ? item?.accumulationAmtWhenBuyConfirm : 0) -
                          (item?.accumulationUseInfo?.usable ? Number(disCountAcc) : 0)
                  )}
                  원
                </p>
              </>
            </div>
          )}

          {/* 페이백 적립금 5% + 추가적립금 */}
          {hasAccessToken && item?.accumulationInfo?.amount > 0 ? (
            <div className='save_mileage'>
              <p>
                {`페이백 적립금 ${item?.accumulationInfo.rewardRateOfProduct}% `}
                {plusComma(item?.accumulationInfo?.amount)}
                <img src={`${imgURL}/icon_point.png`} alt='' />
              </p>
            </div>
          ) : null}

          {/* 별점 */}
          <div className='star_rating'>
            <IconStarOn width={isMobile ? 14 : 16} height={isMobile ? 14 : 16} />
            <span className='review_rating'>{item?.reviewRating}</span>
            <span className='review_num'>({item?.totalReviewCount})</span>

            {/* Npay */}
            <div className='npay'>
              <img src={`${imgURL}/icon_npay.png`} alt='Naver Pay' />
            </div>
          </div>
        </div>
      </div>
      <div className='button_area'>
        {item?.isSoldOut ? (
          <BtnCart
            className='btn_cart'
            onClick={() => {
              setIsModals(true)
            }}
          >
            {/* <img src={`${imgURL}/icon_cart.png`} alt="" /> */}
            {/* <img src={`${imgURL}/icon_cart_soldout.svg`} alt='' /> */}
            {!isMobile ? `재입고 알림` : null}
          </BtnCart>
        ) : (
          <BtnCart
            className='btn_cart'
            onClick={() => {
              setIsModals(true)
            }}
          >
            <img src={`${imgURL}/icon_cart.png`} alt='' /> {!isMobile ? `장바구니` : null}
          </BtnCart>
        )}
        <LikeBtn item={item} />
      </div>
      {isModals ? (
        isMobile ? (
          <ProductModal
            setIsModal={setIsModals}
            headerText={'옵션선택'}
            selectProductNo={item.productNo}
            wonShopBol={wonShop}
            listItem={items}
          ></ProductModal>
        ) : (
          <ProductCenterModal
            setIsModal={setIsModals}
            headerText={'옵션선택'}
            selectProductNo={item.productNo}
            wonShopBol={wonShop}
            listItem={items}
          ></ProductCenterModal>
        )
      ) : null}
    </div>
  )
}
// 마이쇼핑 최근 본 상품 목록형
export const ProductListItemWrap = styled(ProductItemWrap)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 12px;
  @media screen and (min-width: 768px) {
    grid-gap: 16px;
    border: 1px blue solid;
  }
`

export const ProductListImageArea = styled(ProductImageArea)`
  min-width: 138px;
  margin: 0;
  @media screen and (min-width: 768px) {
    width: 200px;
    grid-gap: 16px;
    border: 1px blue solid;
  }
`

export const BtnListCart = styled(BtnCart)`
  width: 100%;
  max-width: 100%;
  margin-bottom: 0;
  & img {
    width: 20px;
    height: 20px;
  }
`

export const ListContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 3px;
  min-width: 166.5px;
`

export const ProductListTitile = styled(ProductTitle)`
  margin-bottom: 4px;
  font-size: 14px;
`

export const ProductListBrandTitile = styled(ProductBrandTitile)`
  margin-bottom: 2px;
`

export const ProductSaleListPrice = styled(ProductSalePrice)`
  margin-bottom: 2px;
`

export const DiscountedListPrice = styled(DiscountedPrice)`
  margin-bottom: 4px;
`
